import { BrandingConfig } from "@shared/types";
import { mediaUrl } from "@/lib/api";

const CORNER_CLASS: Record<BrandingConfig["logoCorner"], string> = {
  "top-left": "top-4 left-4",
  "top-right": "top-4 right-4",
  "bottom-left": "bottom-4 left-4",
  "bottom-right": "bottom-4 right-4",
};

/** Persistent clinic logo shown over the playlist in a chosen corner. */
export function LogoOverlay({ branding, hidden }: { branding?: BrandingConfig; hidden?: boolean }) {
  if (hidden || !branding?.logoKey) return null;
  return (
    <img
      src={mediaUrl(branding.logoKey)}
      alt="Clinic logo"
      className={`pointer-events-none absolute z-20 ${CORNER_CLASS[branding.logoCorner]}`}
      style={{ height: `${branding.logoSizePct}vh`, opacity: branding.logoOpacity / 100 }}
    />
  );
}
